import { Checkbox, Field, RadioGroup } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { isNil } from 'ramda';
import { useSelector } from 'react-redux';
import { TestCompletion } from '../../types';
import { MeasurementCalculationSection } from './MeasurementCalculationSection';
let MeasurementsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const resultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('Measurements.ResultNotObtainable'), valueOrDefault(false))
  );
  const testComplete =
    useSelector(createWorksheetSelector!('Measurements.TestCompletion')) === TestCompletion.TestComplete;
  const unableToPenetrateFurther =
    useSelector(createWorksheetSelector!('Measurements.TestCompletion')) === TestCompletion.TestStopped;
  const resultNotObtainableDisabled = useSelector(
    pipe(createWorksheetSelector!('Measurements.Measurements'), (m) =>
      m.slice(1).some((x: any) => !isNil(x.PenetrationReading))
    )
  );

  return (
    <NamePrefixModifier appendNamePrefix="Measurements">
      <ListFieldSection>
        <FieldSet>
          <Field disabled={resultNotObtainableDisabled} input={<Checkbox />} name="ResultNotObtainable" />
          <Field
            input={<RadioGroup />}
            options={[{ label: 'Material not suitable', value: 'Material not suitable' }]}
            freeEntry={true}
            freeEntryLabel="Other"
            defaultValue="Material not suitable"
            name="ResultNotObtainableReason"
            visible={resultNotObtainable}
          />
        </FieldSet>
      </ListFieldSection>

      <MeasurementCalculationSection disabled={unableToPenetrateFurther || testComplete} visible={!resultNotObtainable}>
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            name="TestCompletion"
            options={[
              { value: TestCompletion.InProgress, label: 'In progress' },
              {
                value: TestCompletion.TestComplete,
                label: 'Test complete',
                disabled: !resultNotObtainableDisabled,
              },
              {
                value: TestCompletion.TestStopped,
                label: 'Test stopped: Unable to penetrate further',
                disabled: !resultNotObtainableDisabled,
              },
            ]}
          />
        </ListFieldSection>
      </MeasurementCalculationSection>
    </NamePrefixModifier>
  );
};

const MeasurementsSection = withInjectedProps(MeasurementsSectionBase);
export { MeasurementsSection };
export default MeasurementsSection;
